module.exports = __webpack_public_path__ + "static/Toad-8cbdd6fa125eb989b98be40ca5774141.jpg";